import React, { useState } from 'react';
import EditCategory from '../components/EditCategory';
import EditMenuItems from '../components/EditMenuItems';

const EditMenu = () => {
  const [activeTab, setActiveTab] = useState('category'); // default to category

  return (
    <div className="p-4">
      <div className="flex gap-4 mb-4">
        <button
          onClick={() => setActiveTab('category')}
          className={`px-4 py-2 rounded ${
            activeTab === 'category' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
          }`}
        >
          Edit Menu Categories
        </button>
        <button
          onClick={() => setActiveTab('items')}
          className={`px-4 py-2 rounded ${
            activeTab === 'items' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
          }`}
        >
          Edit Menu Items
        </button>
      </div>

      <div>
        {activeTab === 'category' ? <EditCategory /> : <EditMenuItems />}
      </div>
    </div>
  );
};

export default EditMenu;
